export var DEFAULT_TIP_PERCENTAGE_OPTIONS = [0, 10, 15, 20];
export var DEFAULT_TIP_PERCENTAGE = 0;
export var TIP_MAX_VALUE = 10000;
export var NO_TIP_COPY = 'No Tip';